import { useNavigate } from "react-router-dom";

/**
 * Custom hook for handling navigation actions with button fallback
 * Tries to click an existing button first, then falls back to navigation
 */
export const useNavigationActions = () => {
  const navigate = useNavigate();

  /**
   * Triggers add bookmark action
   * First tries to click the add bookmark button, then falls back to navigation
   */
  const triggerAddBookmark = () => {
    triggerButtonOrNavigate("add-bookmark-button", "/#add");
  };

  /**
   * Triggers create collection action
   * First tries to click the create collection button, then falls back to navigation
   */
  const triggerCreateCollection = () => {
    triggerButtonOrNavigate("create-collection-button", "/collections#create");
  };

  /**
   * Generic function to trigger button or navigate
   * @param {string} buttonId - The ID of the button to try clicking
   * @param {string} fallbackPath - The path to navigate to if button is not found
   */
  const triggerButtonOrNavigate = (buttonId, fallbackPath) => {
    const button = document.getElementById(buttonId);
    if (button) {
      button.click();
    } else {
      navigate(fallbackPath);
    }
  };

  return {
    triggerAddBookmark,
    triggerCreateCollection,
    triggerButtonOrNavigate,
  };
};
